var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMintYourImpactBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 878,
    viewBox: "0 0 1440 878",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_314_8076)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 878,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 950.211,
    cy: 89.7136,
    r: 11.25,
    transform: "rotate(98.69 950.211 89.7136)",
    fill: "#E3724B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 796.572,
    cy: 67.3689,
    r: 7.875,
    transform: "rotate(98.69 796.572 67.3689)",
    fill: "#E3724B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 769.567,
    cy: 177.048,
    r: 3.375,
    transform: "rotate(98.69 769.567 177.048)",
    fill: "#E3724B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 741.544,
    cy: 732.692,
    r: 21.375,
    transform: "rotate(144.426 741.544 732.692)",
    fill: "#BEBBF3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 602.834,
    cy: 843.507,
    r: 5.625,
    transform: "rotate(98.69 602.834 843.507)",
    fill: "#E3724B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 526.766,
    cy: 812.534,
    r: 5.625,
    transform: "rotate(98.69 526.766 812.534)",
    fill: "#8BBD4F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1062.69,
    cy: 530.265,
    r: 4.5,
    transform: "rotate(98.69 1062.69 530.265)",
    fill: "#E3724B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 890.315,
    cy: 764.536,
    r: 4.5,
    transform: "rotate(98.69 890.315 764.536)",
    fill: "#E3724B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 601.959,
    cy: 737.534,
    r: 3.375,
    transform: "rotate(98.69 601.959 737.534)",
    fill: "#4E92C7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 703.535,
    cy: 437.815,
    r: 12.375,
    transform: "rotate(98.69 703.535 437.815)",
    fill: "#3C2987"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 900.39,
    cy: 222.081,
    r: 2.25,
    transform: "rotate(98.69 900.39 222.081)",
    fill: "#8BBD4F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 933.073,
    cy: 231.628,
    r: 3.375,
    transform: "rotate(98.69 933.073 231.628)",
    fill: "#8BBD4F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 956.553,
    cy: 189.695,
    r: 2.25,
    transform: "rotate(98.69 956.553 189.695)",
    fill: "#E3724B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 700.28,
    cy: 608.027,
    r: 4.5,
    transform: "rotate(98.69 700.28 608.027)",
    fill: "#E3724B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1259.53,
    cy: 504.663,
    r: 21.375,
    transform: "rotate(-14.2641 1259.53 504.663)",
    fill: "#539888"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1429.02,
    cy: 451.834,
    r: 5.625,
    transform: "rotate(-60 1429.02 451.834)",
    fill: "#E3724B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1169.63,
    cy: 230.623,
    r: 9,
    transform: "rotate(-60 1169.63 230.623)",
    fill: "#539888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.27 140.781C1340.14 145.907 1343.19 157.26 1338.06 166.138C1332.93 175.016 1321.58 178.058 1312.7 172.932C1303.82 167.807 1300.78 156.454 1305.91 147.576C1311.03 138.697 1322.39 135.655 1331.27 140.781Z",
    fill: "#4E92C7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1343.74,
    cy: 268.795,
    r: 13.5,
    transform: "rotate(-60 1343.74 268.795)",
    fill: "#E7D869"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 886.772,
    cy: 576.541,
    r: 4.5,
    transform: "rotate(-60 886.772 576.541)",
    fill: "#E3724B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1132.5,
    cy: 420.931,
    r: 4.5,
    transform: "rotate(-60 1132.5 420.931)",
    fill: "#E3724B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1391.33,
    cy: 550.879,
    r: 3.375,
    transform: "rotate(-60 1391.33 550.879)",
    fill: "#E3724B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1187.77,
    cy: 793.192,
    r: 12.375,
    transform: "rotate(-60 1187.77 793.192)",
    fill: "#3C2987"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1252.66,
    cy: 635.8,
    r: 4.5,
    transform: "rotate(-60 1252.66 635.8)",
    fill: "#E3724B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_314_8076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 878,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintYourImpactBackground);
export default __webpack_public_path__ + "static/media/mint-your-impact-background.3b1da7a1caf4196792bc25b74866ea75.svg";
export { ForwardRef as ReactComponent };